import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";
import Icon from "../icon";
import OutboundLink from "../outbound-link";
import NetlifyForm from "react-netlify-form";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";
import ReCaptcha from "react-google-recaptcha";
import { console } from "window-or-global";

const availableApps = ["rccit", "rcrit", "bcjit", "DBAbit", "SLaMAfit"];

class Contact extends React.Component {
  state = {
    name: "",
    surname: "",
    email: "",
    position: "Student",
    interest: "Yes",
    os: "Windows",

    nameValid: false,
    surnameValid: false,
    emailValid: false,
    captchaValid: false,
    formSendable: false,
  };

  handleChange = (event) => {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  };

  checkFormValidity = () => {
    if (this.state.nameValid && this.state.surnameValid && this.state.emailValid && this.state.captchaValid) {
      this.setState({ formSendable: true });
    } else {
      this.setState({ formSendable: false });
    }
  };

  generateUrl = (appName) => "/it/download/" + appName.substring(0, appName.length - 2);

  render() {
    return (
      <ScrollableAnchor id={"download"}>
        <div>
          <form
            name={this.props.formName}
            netlify="true"
            data-netlify="true"
            netlify-honeypot="bot-field"
            method="post"
            action={this.generateUrl(this.props.formName)}
          >
            <div style={{ border: "1px solid gray", padding: "10%", backgroundColor: "#FCFCFC" }}>
              <h4>Compila il form per scaricare l'applicazione</h4>
              <input type="hidden" name="form-name" value={this.props.formName} />

              <FormControl required>
                <Input
                  color="primary"
                  type="text"
                  placeholder="Nome"
                  label="Name"
                  name="Name"
                  onChange={(event) => {
                    if (event.target.value.length >= 2) {
                      this.setState({ nameValid: true }, () => {
                        this.checkFormValidity();
                      });
                    } else {
                      this.setState({ nameValid: false }, () => {
                        this.checkFormValidity();
                      });
                    }
                    this.setState({ name: event.target.value });
                  }}
                  required
                />
                <br />

                <Input
                  type="text"
                  placeholder="Cognome"
                  name="Surname"
                  onChange={(event) => {
                    event.target.value.length >= 2
                      ? this.setState({ surnameValid: true }, () => {
                          this.checkFormValidity();
                        })
                      : this.setState({ surnameValid: false }, () => {
                          this.checkFormValidity();
                        });
                    this.setState({ surname: event.target.value });
                    this.checkFormValidity();
                  }}
                  required
                />
                <br />

                <Input
                  type="email"
                  placeholder="youremail@example.com"
                  name="email"
                  onChange={(event) => {
                    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                    if (!re.test(event.target.value)) {
                      this.setState({ emailValid: false });
                    } else {
                      this.setState({ emailValid: true });
                      this.setState({ email: event.target.value });
                    }
                    this.checkFormValidity();
                  }}
                  required
                />
                <br />
              </FormControl>
              <br />

              <FormControl component="fieldset" required>
                <FormLabel component="legend">Posizione attuale</FormLabel>
                <br />
                <RadioGroup
                  required
                  aria-label="position"
                  name="position"
                  value={this.state.position}
                  onChange={(event) => this.setState({ position: event.target.value })}
                >
                  <FormControlLabel value="Student" control={<Radio style={{ color: "#A661C2" }} />} label="Student" />
                  <FormControlLabel
                    value="Researcher"
                    control={<Radio style={{ color: "#A661C2" }} />}
                    label="Ricercatore"
                  />
                  <FormControlLabel
                    value="Practitioner"
                    control={<Radio style={{ color: "#A661C2" }} />}
                    label="Libero Professionista"
                  />
                  <FormControlLabel value="Other"
                    control={<Radio style={{ color: "#A661C2" }} />}
                    label="Altro" />
                </RadioGroup>
              </FormControl>
              <br />

              <FormControl component="fieldset" required>
                <FormLabel component="legend">
                  Saresti interessato ad un'applicazione economica con cui applicare il metodo SLaMA  (pushover analitica)?
                </FormLabel>
                <RadioGroup
                  aria-label="interest"
                  name="interest"
                  value={this.state.interest}
                  onChange={(event) => this.setState({ interest: event.target.value })}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio style={{ color: "#A661C2" }} />}
                    label="Si" />
                  <FormControlLabel
                    value="No"
                    control={<Radio style={{ color: "#A661C2" }} />}
                    label="No" />
                </RadioGroup>
              </FormControl>
              <br />

              <FormLabel component="legend">OS preferito</FormLabel>
              <br />
              <RadioGroup
                aria-label="os"
                name="os"
                value={this.state.os}
                onChange={(event) => {
                  this.setState({ os: event.target.value });
                }}
              >
                <FormControlLabel value="Windows" control={<Radio style={{ color: "#A661C2" }} />} label="Windows" />
                <FormControlLabel value="Mac" control={<Radio style={{ color: "#A661C2" }} />} label="Mac" />
              </RadioGroup>
              <br />

              <ReCaptcha
                sitekey="6LdT0yIaAAAAADsMl9hUl_GedHU90peT0yBNmEa3"
                onChange={() => {
                  this.setState({ captchaValid: true });
                  this.checkFormValidity();
                }}/>
              <br />

              <Button
                type="submit"
                variant="raised"
                style={{ backgroundColor: "#A661C2", color: "white", opacity: this.state.formSendable ? 1 : 0.5 }}
                disabled={!this.state.formSendable}
              >
                {/* Display "Download" if the app is available, "Ask" if not available */}
                {availableApps.includes(this.props.formName) ? "Download" : "Richiedi"}
              </Button>
            </div>
          </form>
        </div>
      </ScrollableAnchor>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/index.it.jsx